var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-component',{attrs:{"file":_vm.file,"lang":_vm.lang},on:{"onSubmit":_vm.onSubmit,"fetchByLocale":_vm.fetchFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }